import { useState, type FormEvent } from 'react';
import { ApiError } from '../api.js';
import { t } from '../i18n.js';
import { useSession } from '../session.js';

export function LoginPage() {
  const { login } = useSession();
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState<string | null>(null);
  const [busy, setBusy] = useState(false);

  const submit = async (e: FormEvent) => {
    e.preventDefault();
    setBusy(true);
    setError(null);
    try {
      await login(username, password);
    } catch (err) {
      setError(err instanceof ApiError ? err.message : String(err));
    } finally {
      setBusy(false);
    }
  };

  return (
    <div className="login-wrap">
      <div className="login-box">
        <div className="login-logo">
          <img src="/brand/airpost-logo.png" alt="AirPost" width={1200} height={471} />
        </div>
        <div className="panel-title">{t('loginTitle')}</div>
        <div className="sub">{t('loginHint')}</div>
        <form onSubmit={submit}>
          <label htmlFor="u">{t('username')} :</label>
          <input id="u" name="sso-user" autoFocus maxLength={40} value={username} onChange={(e) => setUsername(e.target.value)} autoComplete="username" />
          <label htmlFor="p">{t('password')} :</label>
          <input id="p" name="sso-password" type="password" maxLength={200} value={password} onChange={(e) => setPassword(e.target.value)} autoComplete="current-password" />
          <span />
          <div>
            <button className="btn primary" disabled={busy || !username || !password}>
              {t('login')}
            </button>
            {error && (
              <span className="status err" style={{ marginLeft: 10 }}>
                {error}
              </span>
            )}
          </div>
        </form>
      </div>
    </div>
  );
}
